<template>
    <div class="mobile-app-panel left">
        <Menu @click.native="triggerPanel(false)" />
        <div class="links" @click="triggerPanel(false)" >
            <ul>
                <li>
                    <a target="_blank" href="https://bit.ly/4i9ZIlx">BETLEY TV
                        <svg viewBox="-77 0 512 512"><path d="M98 460L64 426 227 262 64 98 98 64 294 262 98 460Z"/></svg>
                    </a>
                    <router-link :to="{ name: 'Promotions' }">PROMOSYONLAR
                        <svg viewBox="-77 0 512 512"><path d="M98 460L64 426 227 262 64 98 98 64 294 262 98 460Z"/></svg>
                    </router-link>
                    <router-link :to="{ name: 'Affiliate' }">ORTAKLIK PROGRAMI
                        <svg viewBox="-77 0 512 512"><path d="M98 460L64 426 227 262 64 98 98 64 294 262 98 460Z"/></svg>
                    </router-link>
                </li>
            </ul>
        </div>
        <ul class="langs">
            <li v-for="(item, key) in lang" :key="key" :class="{ active : $i18n.locale == item}"><a @click="$i18n.locale = item; $store.dispatch('language/setLanguage', item)" href="javascript:;">
                <img :src="require('@/assets/images/lang/' + item + '.jpg')"> {{ item | ucFirst }}</a>
            </li>
        </ul>
        <div class="button-row" @click="triggerPanel(false)" >
            <a :href="!_.isUndefined(social.livechat_mobile) ? social.livechat_mobile : ''" target="_blank" class="button primary full">CANLI DESTEK</a>
        </div>
    </div>
</template>


<script>
  import FavGames from '../../Slot/FavGames'
  import Menu from './Menu'
  export default{
    data(){
        return{
            tab_menu: 'sport',
        }
    },
    methods:{
        triggerPanel(panel){
            this.$emit('triggerPanel', panel)
        }
    },
    computed:{
        lang(){
            return this.$store.getters.getLanguages;
        },
        social: function() {
            return this.$store.getters.getClientContent;
        },
    },
    components:{
        FavGames,
        Menu
    }
  }
</script>

<style lang="scss">
    .mobile-app-panel .langs{
        display: flex;
        flex-wrap: wrap;
        padding: 0 10px;
        li{
            width: 25%;
            padding: 5px;
            &.active a{
                border-color: var(--c) !important;
                color: var(--client-button-c) !important;
                background: var(--c) !important;
            }
            a{
                text-align: center;
                display: flex;
                align-items: center;
                text-transform: uppercase;
                font-size: 12px;
                padding: 7px 10px;
                border: 1px solid rgb(255 255 255 / 40%);
                border-radius: 5px;
                img{
                    border-radius: 5px;
                    margin-right: 10px;
                    width: 16px;
                }
            }
        }
    }
</style>